import type { LiveClass } from '@openeducation/oe-it-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class LiveClassDao {
  static async getLiveClasses(env: Environment, teacherId: number) {
    const url = hostsConfig[env].liveclassServiceUrl;
    const { data } = await axios.get<LiveClass[]>(
      `${url}/v1/liveclasses?personId=${teacherId}`
    );

    return data;
  }
}
